import apiClient from './apiClient';

/**
 * Fetches the list of students with optional filters
 * @param {Object} query - Filtering and pagination parameters
 * @returns {Promise<Object>} The API response with student data
 */
export const getStudents = async (query = {}) => {
    try {
        const response = await apiClient.get('/students/students', { params: query });
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Fetches a single student by ID
 * @param {string} id - The student's UUID
 * @returns {Promise<Object>} The API response with student details
 */
export const getStudentById = async (id) => {
    try {
        const response = await apiClient.get(`/students/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
